@use "@fukuri-admins/ui/layout" as *;

.screen {
  @include screen;
}

.content {
  @include content;
  height: 100dvh;
}

.body {
  @include body;
}
